module.exports = "<li class=holding-dashboard-sidebar-help-list__item> <svg class=holding-dashboard-sidebar-help-list__chevron width=6 height=9> <use xlink:href=#right-chevron-icon></use> </svg> <a class=\"holding-dashboard-sidebar-help-list__label h-medium-text\" ng-bind=label ng-click=open()> </a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/sidebar-list-link/sidebar-list-link.html
// module id = 300
// module chunks = 0